import { render, staticRenderFns } from "./AnncmntModal.vue?vue&type=template&id=32257dfc&scoped=true"
import script from "./AnncmntModal.vue?vue&type=script&lang=js"
export * from "./AnncmntModal.vue?vue&type=script&lang=js"
import style0 from "./AnncmntModal.vue?vue&type=style&index=0&id=32257dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32257dfc",
  null
  
)

export default component.exports